"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetChildDomain {
    static getAttributeTypeMap() {
        return GetChildDomain.attributeTypeMap;
    }
}
GetChildDomain.discriminator = undefined;
GetChildDomain.attributeTypeMap = [
    {
        "name": "domain",
        "baseName": "domain",
        "type": "string"
    },
    {
        "name": "active",
        "baseName": "active",
        "type": "boolean"
    }
];
exports.GetChildDomain = GetChildDomain;
//# sourceMappingURL=getChildDomain.js.map